import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CalendarHeader from "../components/common/CalendarHeader";
import Dialog from "../components/common/Dialog";
import HeadCont from "../components/common/HeadCont";
// import InputDialog from "../components/diary/InputDialog";
import NewToggle from "../components/common/NewToggle";
import {
  deleteSchedule,
  fetchDrugSchedule,
  fetchDScheduleInfo,
  modifyDrugSchedule,
  saveDrugSchedule,
  scheduleCheck,
  fetchScheduleCalendar,
} from "../../../features/mobile/drugSlice";
import { toast } from "react-toastify";
import toastCommonProps from "../../../common/toast";
import { saveChosenDate } from "../../../features/mobile/commonSlice";
import CustomTimePicker from "../../../components/CustomTimePicker";
import useScrollToTop from "../../../hooks/useScrollToTop";

const DrugAlarm = () => {
    const dispatch = useDispatch();
  useScrollToTop();
  const navigate = useNavigate();
  dayjs.locale("en");
  const { loginInfo, chosenDate } = useSelector((state) => state.commonApp);
  const { existDrugOfYear, fetchDrugStatus, dayDrugLists } = useSelector(
    (state) => state.drug
  );

  // const [openCalendar, setOpenCalendar] = useState(false);
  // const [chosenDate, setChosenDate] = useState(dayjs().format("YYYY-MM-DD"));

  const [dateStart, setDateStart] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );
  const [status, setStatus] = useState({ status: "show", id: null }); // show: display, add: input, edit: edit
  const [openDialog, setOpenDialog] = useState(false);

  const dayArr = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
  ];

  const [checkDay, setCheckDay] = useState(["Every Day"]);

  // Initial check state for medication cycle
  const initCheckState = dayArr.reduce((state, day) => {
    state[day] = false;
    return state;
  }, {});

  // Medication cycle check values
  const [check, setCheck] = useState(initCheckState);

  const [scheduleList, setScheduleList] = useState([]);
  const [alarmCheck, setAlarmCheck] = useState(
    dayDrugLists.reduce((acc, item) => {
      acc[item.id + "_" + item.n] = item.check;
      return acc;
    }, {})
  );

  const [alarmTimes, setAlarmTimes] = useState({
    times: ["08:00", "12:00", "18:00"],
    // times: [],
  });

  // Initial state definition
  const initialState = {
    userId: loginInfo.userId,
    name: "",
    start_day: dateStart,
    period: 1,
    number: 1,
    week: [true, true, true, true, true, true, true],
    hours: [8, 12, 18],
    minutes: [0, 0, 0],
    alarm: [true],
    memo: "",
  };
  // Saved values
  const [value, setValue] = useState({
    userId: loginInfo.userId,
    name: "", // reminder name
    start_day: chosenDate || dateStart, // reminder start day
    period: 1, // medication days
    number: 1, // daily medication count
    week: [true, true, true, true, true, true, true], // alarm cycle
    hours: [8, 12, 18], // hours
    minutes: [0, 0, 0], // minutes
    alarm: [true], // alarm enabled and daily count
    memo: "", // memo
    // cycle: ["Every Day"],
    // time: dayjs(new Date()).format("A HH:mm"),
  });
  const validateValue = () => {
    // Perform validation for each field
    if (!value.userId || value.userId.trim() === "") {
      console.log("userId is empty");
      return false;
    }
    if (!value.name || value.name.trim() === "") {
      console.log("name is empty");
      toast(
        <p>{"Enter a medication name"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
      return false;
    }
    if (!value.start_day || value.start_day.trim() === "") {
      console.log("startDay is empty");
      toast(
        <p>{"Select a start date"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
      return false;
    }
    if (value.period > 180) {
      console.log("Medication days exceed 180 days");
      toast(
        <p>{"Maximum duration is 180 days"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
      return false;
    }
    if (!value.period || value.period === 0) {
      console.log("period is empty or 0");
      toast(
        <p>{"Enter the number of days"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
      return false;
    }
    if (!value.number || value.number === 0 || value.number === "") {
      console.log("number is empty or 0");
      toast(
        <p>{"Enter how many times per day"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
      return false;
    }
    if (!value.week || value.week.length === 0) {
      console.log("week is empty");
      toast(
        <p>{"Select a schedule"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
      return false;
    }
    if (
      !value.hours ||
      !value.minutes ||
      alarmTimes.times.length === 0
      // ||
      // alarmTimes.times.length !== Number(value.number)
    ) {
      console.log("Medication reminder time is empty");
      toast(
        <p>{"Set reminder times"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
      return false;
    }

    // If all validations pass
    if (status.status === "edit") {
      toast(
        <p>{"Reminder updated!"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
    } else {
      toast(
        <p>{"Reminder added!"}</p>,
        toastCommonProps("bottom-center", "toast_alert", 1000)
      );
    }
    return true;
  };

  // Fetch schedule list
  useEffect(() => {
    if (status.status === "show") {
      const params = {
        userId: loginInfo.userId,
        date: chosenDate ? chosenDate : dayjs(new Date()).format("YYYY-MM-DD"),
      };

      dispatch(fetchDrugSchedule(params))
        .unwrap()
        .then((res) => {
          if (res.ok) {
            console.log(res.list, "resresres");
            setScheduleList(res.list);
          } else {
            console.log("Failed to fetch schedule");
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, chosenDate, alarmCheck]);

  // Fetch calendar schedule for the year
  useEffect(() => {
    dispatch(
      fetchScheduleCalendar({
        userId: loginInfo.userId,
        year: dayjs(dateStart).format("YYYY"),
      })
    );
  }, [dayjs(dateStart).format("YYYY"), chosenDate, status]);

  // Display text based on medication cycle day selection
  useEffect(() => {
    const sortDayArray = dayArr.map((day) => check[day]);
    console.log(sortDayArray, "sortDayArray");

    // If all elements are false, default to "Every Day"
    if (sortDayArray.every((value) => value === false)) {
      //   setValue({ ...value, week: [] });
      setCheckDay(["Every Day"]);
      setValue({
        ...value,
        week: [true, true, true, true, true, true, true],
      });
      console.log("Medication cycle value is empty!");
    } else if (sortDayArray.every((value) => value === true)) {
      // When all days of the week are checked
      setCheckDay(["Every Day"]);
      setValue({ ...value, week: sortDayArray });
    } else if (
      sortDayArray[0] === true &&
      sortDayArray[6] === true &&
      sortDayArray.slice(1, 6).every((value) => value === false)
    ) {
      // When only Sun and Sat are checked (weekend)
      setCheckDay(["Weekend"]);
      setValue({ ...value, week: sortDayArray });
    } else if (
      // When only weekdays are checked
      sortDayArray.slice(1, 6).every((value) => value === true) &&
      sortDayArray[0] === false &&
      sortDayArray[6] === false
    ) {
      setCheckDay(["Weekday"]);
      setValue({ ...value, week: sortDayArray });
    } else {
      const filterCheckDay = Object.keys(check).filter(
        (day) => check[day] === true
      );
      setCheckDay(filterCheckDay);
      setValue({ ...value, week: sortDayArray });
    }
  }, [check]);

  const dayCheck = (day) => {
    setCheck((prevChecks) => {
      // Logic to select days other than "Every Day"
      // Activate other days only when "Every Day" is not selected
      if (!prevChecks["Every Day"]) {
        const updatedChecks = {
          ...prevChecks,
          [day]: !prevChecks[day],
        };

        // Generate cycle array using updated checks
        const trueDays = Object.keys(updatedChecks).filter(
          (day) => updatedChecks[day]
        );
        setCheckDay(trueDays);
        return updatedChecks;
      }

      return prevChecks;
    });
  };
  // Allow only numeric input for medication days
  const periodCheck = (e) => {
    const newValue = e.target.value.replace(/[^0-9]/g, "");

    // If newValue is empty string, set period to 1 (default value)
    // Otherwise, convert newValue to number and set to period
    if (newValue === "") {
      setValue({ ...value, period: 1 });
    } else {
      setValue({ ...value, period: Number(newValue) });
    }
  };

  const correctedTime = (time, index) => {
    setAlarmTimes((prevValue) => {
      // Create a copy of the times array
      const updatedTimes = [...prevValue.times];

      // Set the new time value for the current index
      updatedTimes[index] = time;

      // Set the state with the updated times array
      return { ...prevValue, times: updatedTimes };
    });

    const timeString = String(time);
    const currentTime = dayjs();
    const timeParts = timeString.split(":");

    const correctedHours = currentTime.hour(timeParts[0]);
    const correctedMinutes = currentTime.minute(timeParts[1]);

    // Update time for the current index while keeping existing values for others
    setValue((prevValue) => {
      const newHours = [...prevValue.hours];
      const newMinutes = [...prevValue.minutes];

      dayjs((newHours[index] = Number(correctedHours.format("HH"))));
      dayjs((newMinutes[index] = Number(correctedMinutes.format("mm"))));

      // Generate alarm array to match hours array length and set all values to true
      const newAlarm = newHours.map(() => true);

      return {
        ...prevValue,
        hours: newHours,
        minutes: newMinutes,
        alarm: newAlarm,
      };
    });
  };

  // When medication cycle (cycle) value is empty
  //   useEffect(() => {
  //     if (value.week.length === 0) {
  //       setCheckDay(["Every Day"]);
  //       setValue({ ...value, week: [true, true, true, true, true, true, true] });
  //       console.log("Medication cycle value is empty!");
  //     }
  //   }, [value]);

  // Reset saved values
  const valueReset = () => {
    setValue(initialState);
    setDateStart(dayjs(new Date()).format("YYYY-MM-DD"));
    setAlarmTimes({ ...alarmTimes, times: ["08:00", "12:00", "18:00"] });
    setCheckDay(["Every Day"]);
    setCheck(initCheckState);
  };

  //   const handleChange = (startDay) => {
  //     setDateStart(startDay);
  //     setChosenDate(dayjs(startDay).format("YYYY-MM-DD"));
  //     let params = {
  //       userId: loginInfo.userId,
  //       standardDate: dayjs(dateStart).format("YYYY"),
  //     };
  //     fetchScheduleCalendar(params);
  //     setOpenCalendar(false);
  //   };

  // Toggle button
  const toggle = (index) => {
    if (alarmTimes.times.length !== 0) {
      setValue((prevValue) => {
        // Create a copy of the alarm array
        const newAlarm = [...prevValue.alarm];

        // Toggle the alarm value for the current index
        newAlarm[index] = !newAlarm[index];

        return { ...prevValue, alarm: newAlarm };
      });
    }
  };

  // Convert time string to 12-hour format
  const timeIn12HourFormat = (time) => {
    let [hour, minute] = time.split(":").map(Number);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // 0 hour becomes 12 (AM), 12 or above displayed as PM
    return `${ampm} ${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} `;
  };

  // Combine hours and minutes to generate "HH:MM" format string array
  const combinedTimes = (hours, minutes) => {
    // const hours = [12, 13, 14];
    // const minutes = [10, 20, 30];
    // Generate "HH:MM" format string array
    const editTimes = hours.map((hour, index) => {
      const minute = minutes[index];
      return `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
    });
    // Update state with generated array
    setAlarmTimes({ ...alarmTimes, times: editTimes });
  };

  // Alarm schedule registration API
  const upLoadAlarm = async () => {
    // Call validation function
    if (!validateValue()) {
      console.log("Invalid input");

      return; // Exit function if invalid
    }
    const params = {
      userId: loginInfo.userId,
      name: value.name, // reminder name
      start_day: chosenDate || dateStart, // reminder start day
      period: value.period, // medication days
      number: value.number, // daily medication count
      week: value.week, // alarm cycle
      hours: value.hours.slice(0, value.number), // hours
      minutes: value.minutes.slice(0, value.number), // minutes
      alarm: value.alarm.slice(0, value.number), // alarm enabled and daily count
      memo: value.memo,
    };
    await dispatch(saveDrugSchedule(params))
      .unwrap()
      .then((res) => {
        console.log("Save response:", res);
        if (res.ok) {
          console.log(res, "Response complete");
          valueReset();
          dispatch(
            fetchScheduleCalendar({
              userId: loginInfo.userId,
              year: dayjs(dateStart).format("YYYY"),
            })
          );
          setStatus({ status: "show", id: null });
        } else {
          console.log(res, "Response failed?");
          toast(
            <p>{res.error || "Failed to save reminder. Please try again."}</p>,
            toastCommonProps("bottom-center", "toast_alert", 2000)
          );
        }
      })
      .catch((err) => {
        console.error("Failed to save medication schedule:", err);
        toast(
          <p>{"An error occurred while saving. Please try again."}</p>,
          toastCommonProps("bottom-center", "toast_alert", 2000)
        );
      });
  };
  // Alarm schedule detail info API
  const fetchScheduleInfo = async (id) => {
    try {
      const res = await dispatch(fetchDScheduleInfo(id)).unwrap();

      if (res) {
        const checkDaycall = dayArr.reduce((state, day, index) => {
          state[day] = res.info.week[index];
          return state;
        }, {});
        setValue(res.info);
        combinedTimes(res.info.hours, res.info.minutes);
        setCheck(checkDaycall);
      } else {
        console.log("Failed to load edit page data!");
      }
    } catch (error) {
      console.error("Error during edit operation: ", error);
    }
  };

  // Alarm schedule update API
  const modifySchedule = async (id) => {
    // Call validation function
    if (!validateValue()) {
      console.log("Invalid input");

      return; // Exit function if invalid
    }
    await dispatch(modifyDrugSchedule(value))
      .unwrap()
      .then((res) => {
        console.log("Update response:", res);
        if (res.ok) {
          console.log(res, "Update response complete");
          valueReset();
          dispatch(
            fetchScheduleCalendar({
              userId: loginInfo.userId,
              year: dayjs(dateStart).format("YYYY"),
            })
          );
          setStatus({ status: "show", id: null });
        } else {
          console.log(res, "Update response failed?");
          toast(
            <p>{res.error || "Failed to update reminder. Please try again."}</p>,
            toastCommonProps("bottom-center", "toast_alert", 2000)
          );
        }
      })
      .catch((err) => {
        console.error("Failed to update medication schedule:", err);
        toast(
          <p>{"An error occurred while updating. Please try again."}</p>,
          toastCommonProps("bottom-center", "toast_alert", 2000)
        );
      });
  };

  // Alarm schedule delete API
  const deleteAlarmSchedule = async (id) => {
    try {
      const res = await dispatch(deleteSchedule(id)).unwrap();
      console.log("Delete response:", res);

      if (res && res.ok) {
        console.log(res, "deleteAlarmSchedule res");
        valueReset();
        dispatch(
          fetchScheduleCalendar({
            userId: loginInfo.userId,
            year: dayjs(dateStart).format("YYYY"),
          })
        );
        toast(
          <p>{"Reminder deleted!"}</p>,
          toastCommonProps("bottom-center", "toast_alert", 1000)
        );
        setStatus({ status: "show", id: null });
      } else {
        console.log("Failed to delete data!");
        toast(
          <p>{"Failed to delete reminder. Please try again."}</p>,
          toastCommonProps("bottom-center", "toast_alert", 2000)
        );
      }
    } catch (error) {
      console.error("Error during delete operation: ", error);
      toast(
        <p>{"An error occurred while deleting. Please try again."}</p>,
        toastCommonProps("bottom-center", "toast_alert", 2000)
      );
    }
    setOpenDialog(false);
  };

  // Check alarm schedule completion status
  const checkSchedule = async (id, n, isAlarmEnabled) => {
    // Don't allow checking/unchecking if alarm is disabled
    if (!isAlarmEnabled) {
      console.log("Alarm is disabled, cannot change check status");
      return;
    }

    const key = id + "_" + n;
    const updatedCheck = !alarmCheck[key]; // Pre-calculate the state to be updated

    console.log(alarmCheck, "alarmCheck");
    console.log(updatedCheck, "updatedCheck");

    const params = {
      userId: loginInfo.userId,
      id: id,
      date: chosenDate,
      n: n,
      check: updatedCheck,
    };
    await dispatch(scheduleCheck(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          console.log(res, "Checkres");
          console.log("Schedule check complete");
          setAlarmCheck((prevAlarmCheck) => ({
            ...prevAlarmCheck,
            [key]: updatedCheck, // Update state with calculated value
          }));
        } else {
          console.log("Schedule check failed");
        }
      });
  };

  return (
    <>
      {status.status === "show" ? (
        <>
          <HeadCont
            title={"Medication Reminders"}
            transparent={"white"}
            underline={true}
            onLeftAction={() => navigate(-1)}
            onRightAction={() => navigate("/home")}
            rightIcon={"home"}
          />

          <CalendarHeader
            type={"MEDICATION_REMINDER"}
            startDate={dateStart}
            setStartDate={setDateStart}
            chosenDate={chosenDate}
            // setChosenDate={setChosenDate}
            existDaysOfYear={[...(existDrugOfYear || [])]}
          />
          <div className="-mt-[28px] rounded-tl-[28px] bg-white p-6 pb-24">
            <div className="pt-[10px]">
              {scheduleList?.length === 0 ? (
                <p className="text-xl font-bold text-[#05040D]">
                  {"Set up a medication reminder"}
                </p>
              ) : (
                <ul className="flex flex-col gap-[10px]">
                  {scheduleList.map((list, i) => {
                    return (
                      <li
                        key={i}
                        className={`flex justify-between items-center gap-2 rounded-[10px] border-[2px]  ${
                          list.alarm === true
                            ? "border-new_green_100 bg-white"
                            : "border-gray_60 bg-gray_60"
                        }  px-[12px]`}
                      >
                        <div
                          className="flex flex-col justify-center gap-2 py-4 flex-1 min-w-0"
                          onClick={() => {
                            fetchScheduleInfo(list.schedule_id);
                            setStatus({
                              ...status,
                              status: "edit",
                              id: list.schedule_id,
                            });
                          }}
                        >
                          <div className="flex items-center">
                            <span className="line-clamp-2 text-ellipsis whitespace-normal text-[18px] font-semibold leading-[20px] text-[#0D0D0D] max-w-full">
                              {list.name}
                            </span>
                          </div>
                          <div className="flex items-center gap-[6px] text-[#454545]">
                            <img
                              src="/images/mobile/icon/alarm_clock.svg"
                              alt={"Alarm"}
                            />
                            <p className="text-base font-semibold text-neutral-400">
                              {/* {list.hour}:{list.minute} */}
                              {timeIn12HourFormat(
                                `${list.hour}:${list.minute}`
                              )}
                            </p>
                          </div>
                        </div>
                        <div
                          key={list.id + list.n}
                          className={
                            ` my-auto flex h-[40px] min-w-[110px] shrink-0 items-center justify-center gap-2.5 rounded-[60px] border-[2px] border-new_green_100 px-4 py-2 ` +
                            (list.alarm === false
                              ? ` ""`
                              : list.check
                              ? " bg-new_green_100"
                              : " bg-white") +
                            (list.alarm === false ? " opacity-50" : " cursor-pointer")
                          }
                          onClick={() => checkSchedule(list.id, list.n, list.alarm)}
                        >
                          <span
                            className={
                              ` text-base font-bold ` +
                              (list.alarm === false
                                ? ` text-new_green_100`
                                : list.check
                                ? " text-white"
                                : " text-new_green_100")
                            }
                          >
                            {list.alarm === false
                              ? "Disabled"
                              : list.check
                              ? "Taken"
                              : "Scheduled"}
                          </span>
                        </div>
                        {/* <img
                            src="/images/mobile/icon/chevron_skyblue.svg"
                            alt="Edit"
                          /> */}
                      </li>
                    );
                  })}
                </ul>
              )}
              <button
                onClick={() => setStatus({ ...status, status: "add" })}
                className="fixed left-6 right-6 rounded-2xl bg-[#3A404D] p-4 text-body3_700 text-white"
                style={{bottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))'}}
              >
                {"Add Reminder"}
              </button>
            </div>
          </div>
        </>
      ) : status.status === "add" || status.status === "edit" ? (
        <>
          <HeadCont
            title={status.status !== "edit" ? "Set Up Medication Reminder" : ""}
            transparent={"white"}
            underline={true}
            onLeftAction={() => {
              setStatus({ ...status, status: "show", id: null });
              valueReset();
            }}
            onRightAction={() => navigate("/home")}
            rightIcon={"home"}
          />

          <div className="safe-area-mt-header flex w-full flex-col gap-2 p-5 text-base font-bold text-[#444444]">
            <div className="flex-col items-start gap-2.5 py-2.5">
              <p className="text-xl font-extrabold text-gray-950">
                {"Medication Schedule"}
              </p>
              <p className="text-lg font-semibold text-zinc-500">
                <span className="text-lg font-semibold text-emerald-500">
                  {"Add a medication to set up reminders".split(" ")[0]}{" "}
                </span>{" "}
                {"Add a medication to set up reminders".split(" ").slice(1).join(" ")}
              </p>
            </div>
            <label className="my-[10px]">
              {"Medication Name"}
              <input
                name="name"
                type="text"
                placeholder={"e.g., Ibuprofen"}
                value={value.name}
                className="my-[10px] w-full rounded-md border border-[#DFDFDF] p-[10px] font-semibold text-[#545454] focus:outline-none focus:ring-0"
                onChange={(e) =>
                  setValue({ ...value, name: e.currentTarget.value })
                }
              />
            </label>
            <label className="my-[10px]">
              <p className="text-lg">{"Duration"}</p>
              <p className="text-base font-bold text-neutral-700">{"Start Date"}</p>
              <input
                name="start_day"
                type="date"
                lang="en"
                value={
                  status.status === "edit"
                    ? value.start_day
                    : chosenDate || dateStart
                }
                pattern="\d{4}-\d{2}-\d{2}"
                placeholder={dayjs().format("YYYY-MM-DD")}
                className="my-[10px] w-full appearance-none rounded-md border border-[#DFDFDF] bg-white p-[10px] text-center font-semibold text-[#545454] focus:outline-none focus:ring-0"
                onChange={(e) => {
                  dispatch(saveChosenDate(e.currentTarget.value));
                  setValue({ ...value, start_day: e.currentTarget.value });
                }}
              />
              {/* <p className="text-base font-bold text-neutral-700">
                {chosenDate
                  ? dayjs(chosenDate).format("YYYY-MM-DD")
                  : "Select a date"}
              </p> */}
            </label>
            <div className="mb-[10px] flex w-full flex-col items-start gap-4">
              <label className="flex w-full flex-col">
                {"Duration"}
                <span className="text-[12px] text-gray_80">{"(Max 180 days)"}</span>
                <div className="flex flex-row items-end gap-2.5">
                  <input
                    name="drug-period"
                    type="number"
                    value={value.period}
                    placeholder="0"
                    className="w-[112px] rounded-md border border-[#DFDFDF] p-2.5"
                    onChange={(e) => periodCheck(e)}
                  />
                  <span>{"days"}</span>
                </div>
              </label>

              <label className="flex w-full flex-col">
                {"Frequency"}
                <span className="text-[12px] text-gray_80">{"(Max 3 times)"}</span>
                <div className="flex flex-row items-end gap-2.5">
                  <input
                    name="drug-number"
                    type="number"
                    placeholder="0"
                    min="1" // Min value setting
                    max="3" // Max value setting
                    value={value.number}
                    className="w-[112px] rounded-md border border-[#DFDFDF] p-2.5"
                    onChange={(e) => {
                      // Regex to allow only numbers, exact match for numbers 1 to 3
                      const regex = /^([1-3]|\s*)$/;

                      // Update state only if input is empty string or matches regex
                      if (regex.test(e.currentTarget.value)) {
                        setValue({
                          ...value,
                          number: e.currentTarget.value === "" ? 1 : Number(e.currentTarget.value),
                        });
                      }
                      // Ignore input if trying to enter non-numeric characters
                    }}
                  />
                  <span>{"times"}</span>
                </div>
              </label>
            </div>

            <label className="my-[10px]">
              <p className="text-lg">{"Reminder Times"}</p>
              <div className="flex flex-col items-center">
                {Array.from({ length: value.number }, (_, index) => (
                  <div
                    key={index}
                    className="flex w-full flex-row items-center justify-between gap-4"
                  >
                    <CustomTimePicker
                      name="time"
                      value={alarmTimes.times[index]} // Time value for current index
                      className="my-[10px]"
                      onChange={(e) =>
                        correctedTime(e.target.value, index)
                      }
                    />
                    <NewToggle
                      isOn={value.alarm[index]}
                      onToggle={() => toggle(index)}
                    />
                  </div>
                ))}
              </div>
            </label>

            <label className="my-[10px]">
              <p className="text-lg">{"Schedule"}</p>
              <div
                name="checkDay"
                onClick={() => setStatus({ ...status, status: "daySet" })}
                className="my-[10px] flex w-full appearance-none flex-row justify-center gap-2 rounded-md border border-[#DFDFDF] bg-white p-[10px] text-center font-semibold text-[#545454] focus:outline-none focus:ring-0"
              >
                {checkDay[1]
                  ? checkDay.map((arr, index) => <div key={index}>{arr}</div>)
                  : checkDay}
                {/* <option value="Every Day">Every Day</option>
                <option value="Sunday">Sunday</option>
                <option value="Monday">Monday</option>
                <option value="Tuesday">Tuesday</option>
                <option value="Wednesday">Wednesday</option>
                <option value="Thursday">Thursday</option>
                <option value="Friday">Friday</option>
                <option value="Saturday">Saturday</option> */}
              </div>
              {/* <p className="text-base font-bold text-neutral-700">
                {chosenDate
                  ? dayjs(chosenDate).format("YYYY-MM-DD")
                  : "Select a date"}
              </p> */}
            </label>

            <label className="mb-[120px]">
              {"Add Notes"}
              <textarea
                name="memo"
                value={value.memo}
                className="my-[10px] h-64 w-full rounded-md border border-[#DFDFDF] p-[10px] font-semibold text-[#545454] focus:outline-none focus:ring-0"
                placeholder={"Add any notes..."}
                onChange={(e) =>
                  setValue({ ...value, memo: e.currentTarget.value })
                }
              />
            </label>
            {/* <InputDialog
              option={option}
              openDialog={openDialog}
              setOpenDialog={setOpenDialog}
              chosenDate={chosenDate}
              onSaveDiary={onSaveDiary}
              symptomArr={symptomArr}
              // feelings={feelings}
            /> */}
          </div>

          <div className="fixed bottom-0 left-0 right-0 flex gap-[10px] bg-white px-6 pb-4 pt-4 text-body3_700" style={{paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))'}}>
            {status.status === "edit" ? (
              <>
                <button
                  className="w-2/5 rounded-2xl border border-[#3A404D] bg-white p-4 text-[#3A404D]"
                  onClick={() => setOpenDialog(true)}
                >
                  {"Delete"}
                </button>
                <button
                  className={`w-3/5 rounded-2xl p-4 text-white ${
                    value.name && value.name.trim() !== ""
                      ? "bg-[#3A404D]"
                      : "bg-[#939393]"
                  }`}
                  onClick={() => {
                    modifySchedule();
                  }}
                >
                  {"Save"}
                </button>
              </>
            ) : (
              <button
                className={`w-full rounded-2xl p-4 text-white ${
                  value.name && value.name.trim() !== ""
                    ? "bg-[#3A404D]"
                    : "bg-[#939393]"
                }`}
                onClick={() => {
                  upLoadAlarm();
                }}
              >
                {"Save"}
              </button>
            )}
          </div>

          {openDialog && (
            <Dialog
              innerClass={"p-4"}
              title={"Delete Reminder"}
              desc={"Would you like to delete this reminder from the list?"}
              leftBtnTitle={"Yes, delete it"}
              rightBtnTitle={"No"}
              onLeftBtnAction={() => {
                deleteAlarmSchedule(value.schedule_id);
              }}
              onRightBtnAction={() => setOpenDialog(false)}
              onCoverAction={() => setOpenDialog(false)}
            />
          )}
        </>
      ) : (
        <div className="flex flex-wrap">
          <HeadCont
            title={""}
            transparent={"white"}
            underline={true}
            onLeftAction={() =>
              status.id === null
                ? setStatus({ ...status, status: "add" })
                : setStatus({ ...status, status: "edit" })
            }
          />
          <div className="mx-[30px] safe-area-mt-header flex w-full flex-col flex-wrap items-center gap-2 py-2.5">
            <div className="flex w-full flex-col items-start gap-2 py-2.5">
              <p className="text-lg font-bold text-neutral-700">{"Days"}</p>
              <div className="flex w-full flex-col items-center">
                {/* Everyday Button */}
                <div
                  className="mb-2 flex w-full items-center justify-between rounded-[5px] border border-gray_60 bg-white px-6 py-2.5 text-center"
                  onClick={() => {
                    const allChecked = dayArr.every((day) => check[day] === true);
                    const newCheckState = dayArr.reduce((state, day) => {
                      state[day] = !allChecked;
                      return state;
                    }, {});
                    setCheck(newCheckState);
                  }}
                >
                  <span className="text-lg font-bold text-zinc-500">
                    {"Every Day"}
                  </span>
                  {dayArr.every((day) => check[day] === true) ? (
                    <img src="/images/mobile/icon/checkOn.svg" alt={"Checked"} />
                  ) : (
                    <img
                      src="/images/mobile/icon/checkOff.svg"
                      alt={"Unchecked"}
                    />
                  )}
                </div>
                {dayArr.map((day, i) => (
                  <div
                    key={day + i}
                    className="mb-2 flex w-full items-center justify-between rounded-[5px] border border-gray_60 bg-white px-6 py-2.5 text-center"
                    onClick={() => {
                      dayCheck(day);
                      setCheckDay(check[day]);
                    }}
                  >
                    <span className="text-lg font-bold text-zinc-500">
                      {day}
                    </span>
                    {check[day] === false ? (
                      <img
                        src="/images/mobile/icon/checkOff.svg"
                        alt={"Unchecked"}
                      />
                    ) : (
                      <img src="/images/mobile/icon/checkOn.svg" alt={"Checked"} />
                    )}
                  </div>
                ))}
              </div>
              <button
                onClick={() =>
                  status.id === null
                    ? setStatus({ ...status, status: "add" })
                    : setStatus({ ...status, status: "edit" })
                }
                className="flex w-full justify-center rounded-2xl bg-[#3A404D] p-4  text-body3_700 text-white"
              >
                {"Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* <CalendarDialog
        type={"MEDICATION_REMINDER"}
        startDate={dateStart}
        setStartDate={setDateStart}
        handleChange={handleChange}
        chosenDate={chosenDate}
        existDates={[...existDaysOfYear]}
        openCalendar={openCalendar}
        setOpenCalendar={setOpenCalendar}
      /> */}
    </>
  );
};

export default DrugAlarm;
